export default "__VITE_ASSET__Dh4J1koA__"